export default __webpack_public_path__ + "static/media/EMB.a9d35717.png";